import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { userColumns } from "./datatablesource"; // Assuming userColumns is correctly imported

const Datatable = () => {
  const [data, setData] = useState([]);
  const location = useLocation(); // Hook to get current URL
  const contestId = new URLSearchParams(location.search).get("uid"); // Extract contest_id from URL

  useEffect(() => {
    const fetchData = async () => {
      if (!contestId) {
        console.error("Contest ID not found in URL");
        return;
      }

      try {
        const leaderboardRef = collection(db, "mycontest");
        const q = query(
          leaderboardRef,
          where("contest_id", "==", contestId), // Use extracted contest_id for filtering
          orderBy("correctanswers", "desc"),
          orderBy("countdown"),
          orderBy("timestamp")
        );

        const unsubscribe = onSnapshot(
          q,
          (snapshot) => {
            const list = [];
            snapshot.forEach((doc) => {
              const data = doc.data();
              list.push({
                id: doc.id,
                contest_id: data.contest_id,
                correctanswers: data.correctanswers,
                countdown: data.countdown,
                timestamp: data.timestamp,
                contest_topic: data.contest_topic || "",
                userImage: data.userImage || "",
                userName: data.userName || "",
                userEmail: data.userEmail || "",
                userPhone: data.userPhone || "",
                user_id: data.user_id || "",
                status: data.status || "",
              });
            });
            setData(list);
          },
          (error) => {
            console.error("Error fetching snapshot:", error);
          }
        );

        return unsubscribe; // Return the unsubscribe function
      } catch (error) {
        console.error("Error fetching leaderboard:", error);
      }
    };

    fetchData();

    // Cleanup function
    return () => {}; // No cleanup needed if unsubscribe is handled in fetchData
  }, [contestId]); // Dependency on contestId ensures useEffect runs when contestId changes

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <Link
              to={`/leaderboard/fullview?uid=${params.row.user_id}&contestid=${params.row.contest_id}&position=${data.findIndex(item => item.id === params.row.id) + 1}`} // Position starts from 1
            style={{ textDecoration: "none" }}
          >
            <div className="viewButton">View</div>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      <DataGrid
        className="datagrid"
        rows={data}
        columns={[...userColumns, ...actionColumn]}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
};

export default Datatable;
